import { GET_LODGING_POLICY_FAILURE, GET_LODGING_POLICY_REQUEST, GET_LODGING_POLICY_SUCCESS, GET_LODGING_POLICY_CLEAR, GetLodgingPolicyActionTypes, GetLodgingPolicyState } from './types';

const defaultState: GetLodgingPolicyState = {
  isLoading: false,
  errorMessage: "",
};

export default function getLodgingPolicy(state = defaultState, action: GetLodgingPolicyActionTypes): GetLodgingPolicyState {
  switch (action.type) {
    case GET_LODGING_POLICY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGING_POLICY_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_POLICY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_POLICY_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
